import React from "react";
import Template from "../../../components/Dashboard/Template";
import BarChart from "../../../components/Dashboard/BarChart";
import appcolors from "../../../constants/Colors";
import { Typography } from "@mui/material";

function TopMembesrGraph({ data }) {
  return (
    <Template primaryHeading={"Top team member"} secondaryHeading={"Graph"}>
      {data?.length > 0 ? (
        <BarChart data={data} />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
        >
          No Members Found!
        </Typography>
      )}
    </Template>
  );
}

export default TopMembesrGraph;
